import loadable from '@loadable/component';
import React, {useEffect, useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {ActivityIndicator, Platform, StatusBar, Text, View} from 'react-native';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import Package from '../../../package.json';
import {getConfig} from '../../actions/config';

import {market, network, releaseTag} from 'src/constants/config';
import {getUrl} from '../../actions/url';
import {getUser} from '../../actions/user';
import {isWeb, needCodePushUpdate} from '../../constants';
import {useHistory} from '../../imports/Router';
import codePush from '../../imports/codepush';
import {useApi} from '../../providers/ApiProvider';
import {selecetApptype} from '../../selectors/App';
import {selecetusertype} from '../../selectors/User';
import {AnalyticsUserProperties} from '../../services/analytics/FirebaseAnalytics';
import Button from '../button/Button.componet';
import styles from './LoadSplash.style';
import {getMap} from '../../actions/map';
import useCheckVpn from '../../utils/useCheckVpn';
import Splash from '../../imports/splash';
import {
  checkLocationIsValid,
  checkPermitionAndGetPosition,
} from '../../utils/location';
import {selecetmaptype} from '../../selectors/Map';
const SVG = loadable(() => import('../../imports/svg'));
// 1. اپ شروع می‌شود
//    ↓
// 2. LoadSplash → checkPermitionAndGetPosition()
//    ↓
// 3. getUserLocation() → GPS موقعیت می‌گیرد
//    ↓
// 4. getMap() → userPosition در Redux ذخیره می‌شود getMap در src/actions/map.js
//    ↓
// 5. کامپوننت‌ها userPosition را از Redux می‌خوانند
//    ↓
// 6. هنگام pause/resume/end → checkPermitionAndGetPosition()
//    ↓
// 7. اگر موقعیت جدید دریافت شد → استفاده از آن
//    ↓
// 8. اگر دریافت نشد → بررسی اعتبار userPosition قدیمی
//    ↓
// 9. اگر معتبر بود → استفاده از آن، اگر نه → ارسال 0
//===================================================
// B. مکان‌های فراخوانی:
// شروع اپ: LoadSplash.component.js
// شروع سفر: Drive.component.jsx
// Pause/Resume: Drive.component.jsx
// پایان سفر: Drive.component.jsx و EndTripImage.component.js
// آپلود عکس: EndTripImage.component.js
//===================================================
// خلاصه مکان‌ها:
// مستقیم (2 مکان):
// location.js - خط 28-38 (Web)
// location.js - خط 89-102 (Mobile)
// غیرمستقیم (از طریق checkPermitionAndGetPosition):
// VehiclesList.js - هنگام دریافت لیست وسایل
// Map/index.js - هنگام بارگذاری نقشه
// useUserLocationInterval.js - هنگام به‌روزرسانی خودکار
// MapPage.component.js - startTripFromMap شروع سفر
// ReservePage.component.js -startTripHandler شروع سفر
// Drive.component.jsx - هنگام pause/resume/end
// EndTripImage.component.js - هنگام آپلود عکس
// LoadSplash.component.js - هنگام شروع اپ

function LoadSplash() {
  const {t} = useTranslation();
  const history = useHistory();
  const [isUpdated, setIsUpdated] = useState(false);
  const [progress, setProgress] = useState();
  const [hasNet, setHasNet] = useState(true);
  const [syncMessage, setSyncMessage] = useState('');
  const [checkNetLoading, setCheckNetLoading] = useState(false);
  const [isLocationFetched, setIsLocationFetched] = useState(false);
  const {enseraf, token, userStatus, mobile} = useSelector(state =>
    selecetusertype(state),
  );
  const {checkVpn} = useCheckVpn();
  const {isRehydrationComplete} = useSelector(state => selecetApptype(state));
  const {userPosition} = useSelector(state => selecetmaptype(state));

  const {api} = useApi();
  const dispatch = useDispatch();

  const Clearcache = () => {
    window.location.reload();
  };

  const getConfigMutation = useMutation({
    mutationFn: async () => {
      return api.getConfig({
        version: Package?.version,
        type: isWeb ? 'pwa' : 'android',
      });
    },
    onSuccess: response => {
      let data = response?.Data;
      dispatch(
        getUrl({
          BaseUrlApi: network?.baseUrl,
          BaseUrlAuth: network?.baseUrl,
        }),
      );
      data?.status == 'normal' || data?.status == 'critical'
        ? Platform.OS == 'android'
          ? dispatch(getUser({vrnmodaltype: data?.status}))
          : Clearcache()
        : dispatch(getUser({vrnmodaltype: null}));

      setTimeout(() => {
        if (isWeb) {
          setIsUpdated(true);
        }
      }, 500);

      dispatch(
        getConfig({
          location: response?.Data?.config?.location,
          address: response?.Data?.config?.address,
          supportPhone: response?.Data?.config?.support_phone,
          deposit_value: data.config.deposit_value_base,
          deposit_value_motor: data.config.deposit_value_bike,
          min_ride_Bicycle: data.config.min_ride_Bicycle,
          min_ride_Bike: data.config.min_ride_Bike,
          reserveDuration: data.config.reserveDuration,
          station_vehicle_max_distance:
            data.config.station_vehicle_max_distance,
          user_vehicle_max_distance_beep:
            data.config.user_vehicle_max_distance_beep,
          user_vehicle_max_distance_end:
            data.config.user_vehicle_max_distance_end,
          user_vehicle_max_distance_pause_resume:
            data.config.user_vehicle_max_distance_pause_resume,
          user_vehicle_max_distance_start:
            data.config.user_vehicle_max_distance_start,
          max_upload_size: data.config.max_upload_size,
          deposit_value_base: data.config.deposit_value_base,
          polygon: JSON.parse('[' + data.config.polygon + ']'),
          max_allowed_accuracy: data?.config?.max_allowed_accuracy,
          minimum_increasing_amount: data?.config?.minimum_increasing_amount,
          location_validity_time: data?.config?.location_validity_time,
          is_war_mode: data?.config?.is_war_mode,
        }),
      );
    },
    onError: err => {
      setCheckNetLoading(false);
      if (err?.response?.status === 500) {
        history.push('/logout');
      }
      if (err.message === 'Network Error') {
        setHasNet(false);
      }
    },
    retry: (number, error) => {
      if (number < 4 && error.message == 'Network Error') {
        return true;
      } else {
        return false;
      }
    },
  });

  const getUserLocation = () => {
    checkPermitionAndGetPosition({
      timeout: 10000,
      onSuccess: () => {
        setIsLocationFetched(true);
      },
      onError: () => {
        setIsLocationFetched(true);
      },
    });
  };

  useEffect(() => {
    Splash?.hide();
    if (!isWeb) {
      checkForUpdate();
    }
    const locationIsValid = checkLocationIsValid(
      userPosition?.timestamp ?? 0,
      30,
    );
    if (!locationIsValid) {
      getUserLocation();
    } else {
      setIsLocationFetched(true);
    }

    setTimeout(() => {
      getConfigMutation.mutate();
    }, 500);
  }, []);

  const proceedToApp = () => {
    Splash?.hide();
    if (token && mobile) {
      if (
        enseraf ||
        userStatus == 'active' ||
        userStatus == 'profile_submitted' ||
        userStatus == 'profile_rejected'
      ) {
        setTimeout(() => {
          dispatch(
            getMap({
              refreshNearestView: true,
            }),
          );
        }, 2000);
        history.push('/main/map');
      } else {
        history.push('/register');
      }
    } else {
      history.push('/auth');
    }
  };

  useEffect(() => {
    if (
      isUpdated &&
      isRehydrationComplete &&
      getConfigMutation?.isSuccess &&
      isLocationFetched
    ) {
      proceedToApp();
      setTimeout(() => {
        checkVpn()
          .then(() => {})
          .catch(() => {});
      }, 2000);
    }
  }, [
    isUpdated,
    isRehydrationComplete,
    getConfigMutation?.isSuccess,
    isLocationFetched,
  ]);

  const codePushStatusDidChange = syncStatus => {
    switch (syncStatus) {
      case codePush.SyncStatus.CHECKING_FOR_UPDATE:
        setSyncMessage(t('checking_for_update'));
        break;
      case codePush.SyncStatus.DOWNLOADING_PACKAGE:
        setSyncMessage(t('downloading_package'));
        break;
      case codePush.SyncStatus.AWAITING_USER_ACTION:
        setSyncMessage(t('awaiting_user_action'));
        break;
      case codePush.SyncStatus.INSTALLING_UPDATE:
        setSyncMessage(t('installing_update'));
        break;
      case codePush.SyncStatus.UP_TO_DATE:
        setSyncMessage(t('up_to_date'));
        setProgress(undefined);
        break;
      case codePush.SyncStatus.UPDATE_IGNORED:
        console.log('appCenter_update_ignored');
        setSyncMessage(t('update_ignored'));
        setProgress(undefined);
        setIsUpdated(true);
        break;
      case codePush.SyncStatus.UPDATE_INSTALLED:
        setSyncMessage(t('update_installed'));
        Splash?.show();

        setProgress(undefined);
        break;
      case codePush.SyncStatus.UNKNOWN_ERROR:
        setSyncMessage(t('code_push_unknown_error'));
        setProgress(undefined);
        setIsUpdated(true);
        break;
    }
  };

  const checkForUpdate = async () => {
    try {
      const update = await codePush.checkForUpdate(
        '1M8P-5RBjUDJ5vA0X6nlQAZgegd9rwVB01WZj',
      );

      setCheckNetLoading(false);
      setHasNet(true);

      if (update && !__DEV__ && needCodePushUpdate) {
        codePush.sync(
          {
            deploymentKey: '1M8P-5RBjUDJ5vA0X6nlQAZgegd9rwVB01WZj',
            installMode: codePush.InstallMode.ON_NEXT_SUSPEND,
          },
          syncStatus => {
            codePushStatusDidChange(syncStatus);
          },
          progress => {
            setProgress(progress);
          },
        );
      } else {
        setIsUpdated(true);
      }
    } catch (err) {
      console.log('CODE_PUSH_CATCH', err);
      setIsUpdated(true);
    }
  };

  useEffect(() => {
    dispatch(
      getMap({
        firstMapViewPort: true,
      }),
    );
    AnalyticsUserProperties({
      user_market: market,
    });
    console.log(market, 'market');
  }, []);

  const renderProgressView = () => {
    return (
      <Text style={styles.percent}>
        {`${
          progress.totalBytes > 0
            ? Math.round((progress.receivedBytes / progress.totalBytes) * 100)
            : 0
        }%`}
      </Text>
    );
  };

  const tryAgain = () => {
    setCheckNetLoading(true);
    getConfigMutation.mutate();
  };
  


  return (
    <View style={styles.container}>
      <StatusBar hidden />
      <SVG name="logo" width={126} height={64} />
      <View style={styles.textWrapper}>
        <Text style={styles.text}>{t('slogan')}</Text>
        <Text style={styles.text}>{t('for_passengers_and_cargo')}</Text>
        {!hasNet ? (
          <View style={styles.netRow}>
            <Text style={styles.describe}>
              {t('try_again_after_connected_to_internet')}
            </Text>
            <Button
              color={'#303261'}
              style={styles.btncontainer}
              disabled={checkNetLoading}
              onPress={tryAgain}>
              {checkNetLoading ? (
                <ActivityIndicator color={'#fff'} size={'small'} />
              ) : (
                <Text style={[styles.buttontext, {color: '#FFFFFF'}]}>
                  {t('retry')}
                </Text>
              )}
            </Button>
          </View>
        ) : (
          <View style={styles.checkNetFreeSpace} />
        )}
        {progress && hasNet && Platform.OS === 'android' ? (
          renderProgressView()
        ) : hasNet && Platform.OS === 'android' ? (
          <ActivityIndicator color={'#780e10'} size={'small'} />
        ) : null}
        <Text style={styles.status}>{syncMessage}</Text>
        {releaseTag ? <Text style={styles.version}>{releaseTag}</Text> : null}
      </View>
    </View>
  );
}
export default LoadSplash;
